import { configureStore } from "@reduxjs/toolkit";
import accountUploadReducer from './accountUpload/accountUpload-slice'

export const store = configureStore({
  reducer: {
    accountUpload: accountUploadReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
